import { render, staticRenderFns } from "./sysScoreLook.vue?vue&type=template&id=9dc1fa54&"
import script from "./sysScoreLook.vue?vue&type=script&lang=js&"
export * from "./sysScoreLook.vue?vue&type=script&lang=js&"
import style0 from "./sysScoreLook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports